import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { LocalStorageService } from "src/core/services/local-storage.service";
import { MedicineService } from "src/core/services/medicine.service";
import { PrescriptionService } from "src/core/services/prescription.service";
import { Batch, BatchStatus } from "src/interfaces/batch";
import { Medicine } from "src/interfaces/medicine";

@Injectable({
    providedIn: 'root'
})
export class BatchResolver implements Resolve<any> {

    constructor(private prescriptionService: PrescriptionService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Batch | null> {
        return this
            .prescriptionService
            .getBatch(
                parseInt(route.params['id'])
            )
    }
}

@Injectable({
    providedIn: 'root'
})
export class BatchesResolver implements Resolve<any> {
    page: number = 1;
    limit: number = 15;

    constructor(
        private prescriptionService: PrescriptionService,
        private localStorageService: LocalStorageService,
        private _medicineService: MedicineService
    ) {

        const limit = this.localStorageService.get('BATCHES', 'LIMIT');

        if (limit) {
            this.limit = parseInt(limit);
        }
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<
    {
        batches: Batch[],
        pageNumber: number,
        medicine: Medicine [],
        statuses: BatchStatus[]
    }
    > {
        const page = this.localStorageService.get('BATCHES', 'PAGE');
        if (page) {
            this.page = parseInt(page);
        } else {
            this.page = 1;
        }

        const batches: Batch[] = await this.prescriptionService.getBatches(this.page, this.limit);
        const medicine: Medicine[] = await this._medicineService.getMedicineList(1, 15);
        const formData: any = await this.prescriptionService.getFormData(['batch_status']).toPromise();
        const statuses: BatchStatus[] = formData.batch_status;

        return {
            pageNumber: this.page,
            batches: batches,
            medicine,
            statuses
        }
    }
}